export function updateParams(params = {}) {
  window.gsc('params', params);
}

export function showWidget(widget) {
  window.gsc('show', widget);
}

export function closeWidget(widget) {
  window.gsc('close', widget);
}

export const getSiteControlMixin = (widgets = {}) => ({
  methods: {
    $_getSiteControlMixin_updateParams: updateParams,
    $_getSiteControlMixin_showWidget(widget) {
      if (!widgets[widget]) throw new Error(`Widget ${widget} not found`);

      showWidget(widgets[widget]);
    },
    $_getSiteControlMixin_closeWidget(widget) {
      if (!widgets[widget]) throw new Error(`Widget ${widget} not found`);

      closeWidget(widgets[widget]);
    }
  }
});

export const getSiteControlPlugin = {
  install(Vue, { initialParams = {}, widgets = {} } = {}) {
    window.gsc =
      window.gsc ||
      function () {
        // eslint-disable-next-line no-undef
        (gsc.q = gsc.q || []).push(arguments);
      };

    Vue.mixin({
      ...getSiteControlMixin(widgets)
    });

    Vue.$gsc = window.gsc;

    window.gsc('params', initialParams);
  }
};

export default getSiteControlPlugin;
